(function () {
  // Get all the required elements
  const capTypeRadios = document.querySelectorAll('input[name="cap_type"]');
  const audienceCheckboxes = document.querySelectorAll(
    'input[name="audience"]'
  );
  const tagsCheckboxes = document.querySelectorAll('input[name="tags"]');
  const toolkitsRadios = document.querySelectorAll(
    'input[name="original_toolkit"]'
  );
  const resultMessage = document.querySelector("#result-message");

  // Add event listeners to the cap type radios
  capTypeRadios.forEach((radio) => {
    radio.addEventListener("change", filterToolkits);
    radio.addEventListener("change", () => {
      showSection(document.querySelector("#age-range"));
      showSection(document.querySelector("#community"));
    });
  });

  // Call filtering and showSection functions on page load if CAP type radio or audience checkboxes have a value selected
  window.addEventListener("DOMContentLoaded", () => {
    const capType = document.querySelector('input[name="cap_type"]:checked');
    const audienceValues = getSelectedCheckboxValues("audience");

    if (capType) {
      const selectedValue = capType.value;
      if (selectedValue !== "") {
        filterToolkits();
        showSection(document.querySelector("#age-range"));
        showSection(document.querySelector("#community"));
      } else if (audienceValues.length > 0) {
        filterToolkits();
      }
    }
  });

  // Add event listeners to the audience checkboxes
  audienceCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      filterToolkits();
    });
  });

  // Add event listeners to the tags checkboxes
  tagsCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", filterToolkits);
  });

  function showSection(section) {
    section.classList.remove("disabled");
  }

  // Function to get selected checkbox values
  function getSelectedCheckboxValues(name) {
    const checkboxes = document.querySelectorAll(
      `input[name="${name}"]:checked`
    );
    return Array.from(checkboxes).map((checkbox) => checkbox.value);
  }

  // Function to filter the toolkits
  function filterToolkits() {
    const selectedCapType = document.querySelector(
      'input[name="cap_type"]:checked'
    ).value;
    const selectedAudiences = Array.from(
      document.querySelectorAll('input[name="audience"]:checked')
    ).map((checkbox) => checkbox.value);
    const selectedTags = Array.from(
      document.querySelectorAll('input[name="tags"]:checked')
    ).map((checkbox) => checkbox.value);

    let filteredToolkits;
    // Filter toolkits based on cap type
    if (selectedCapType.length > 0) {
      filteredToolkits = Array.from(toolkitsRadios).filter(
        (toolkit) => toolkit.dataset.capType === selectedCapType
      );
    }
    // Filter toolkits based on audience
    if (selectedAudiences.length > 0) {
      filteredToolkits = filteredToolkits.filter((toolkit) => {
        const toolkitAudience = toolkit.dataset.audience.split(",");
        return selectedAudiences.every((item) =>
          toolkitAudience.includes(item)
        );
      });
    }

    // Filter toolkits based on tags
    if (selectedTags.length > 0) {
      filteredToolkits = filteredToolkits.filter((toolkit) => {
        const toolkitTags = toolkit.dataset.communityConsiderations.split(",");
        return selectedTags.every((tag) => toolkitTags.includes(tag));
      });
    }

    // Hide all toolkits
    toolkitsRadios.forEach((toolkit) => {
      toolkit.closest("div").style.display = "none";

      // Uncheck if toolkit is not in filteredToolkits
      if (!filteredToolkits.includes(toolkit)) {
        toolkit.checked = false;
      }
    });
    // Show filtered toolkits
    if (filteredToolkits.length > 0) {
      filteredToolkits.forEach((toolkit) => {
        toolkit.closest("div").style.display = "block";
      });
      hideResultMessage();
    } else {
      showResultMessage();
    }
  }

  // Function to show the result message
  function showResultMessage() {
    resultMessage.style.display = "block";
  }

  // Function to hide the result message
  function hideResultMessage() {
    resultMessage.style.display = "none";
  }
})();
